// extracted by mini-css-extract-plugin
module.exports = {"inner":"SectionTypes_inner__PutGD","left":"SectionTypes_left__v__hY"};